export const EXTERNAL_ROUTE_METADATA = [
    { id: 'login', path: '/login', noRedirectLogin: true },
    { id: 'logout', path: '/logout', noRedirectLogin: true },
    { id: 'changePassword', path: '/change-password', noRedirectLogin: true },
    { id: 'expiredPassword', path: '/expired-password', noRedirectLogin: true },
    { id: 'recoverPassword', path: '/recover-password', noRedirectLogin: true },
    { id: 'signatureConfirm', path: '/signature-confirm', noRedirectLogin: true },
    { id: 'contractsValidation', path: '/contracts-validation' },
    { id: 'acceptInvite', path: '/accept-invite', noRedirectLogin: true },
    { id: 'sageMobileInvite', path: '/sage-mobile-invite', noRedirectLogin: true },
    { id: 'sageMobileSuccess', path: '/sage-mobile-success', noRedirectLogin: true },
    { id: 'sageMobileError', path: '/sage-mobile-error', noRedirectLogin: true },
    { id: 'sageMobileErrorCode', path: '/sage-mobile-error/:code', noRedirectLogin: true },
    { id: 's200ukiOnboarding', path: '/onboarding/s200uki', noRedirectLogin: true },
    { id: 'onboarding', path: '/onboarding', noRedirectLogin: true },
    { id: 'error', path: '/error', noRedirectLogin: true },
    { id: 'errorCode', path: '/error/:code', noRedirectLogin: true },
    { id: 'auth', path: '/auth', noRedirectLogin: true },
    { id: 'salesBiMobile', path: '/salesbi-mobile', noRedirectLogin: true },
    { id: 'emailUnsubscribed', path: '/email-unsubscribed', noRedirectLogin: true },
];

export const INTERNAL_ROUTE_METADATA = [
    { id: 'companies', title: 'page_title_accounts', path: '/companies/*' },
    { id: 'opportunities', title: 'page_title_opportunities', path: '/opportunities/*' },
    { id: 'contacts', title: 'page_title_contacts', path: '/contacts/*' },
    { id: 'campaigns', title: 'page_title_campaigns', path: '/campaigns/*' },
    { id: 'salesOrders', title: 'page_title_salesorders', path: '/sales-orders/*' },
    { id: 'documents', title: 'page_title_documents', path: '/documents/*' },
    { id: 'billboard', title: 'page_title_news', path: '/news/*' },
    { id: 'reports', title: 'page_title_reports', path: '/reports/*' },
    { id: 'kpis', title: 'page_title_goals', path: '/kpis/*' },
    { id: 'agenda', title: 'page_title_calendar', path: '/agenda/*' },
    { id: 'activities', title: 'page_title_activities', path: '/activities/*' },
    {
        id: 'conversationActivities',
        title: 'page_title_activities',
        path: '/conversations/activities/*',
    },
    {
        id: 'metricsDashboard',
        title: 'label_dashboards',
        path: '/metrics/dashboards/view/:id',
    },
    { id: 'metricsSfm', title: 'title_sales_force', path: '/metrics/sfm/:id' },
    { id: 'metrics', title: 'label_metrics_and_reports', path: '/metrics/*' },
    { id: 'products', title: 'page_title_products', path: '/products/*' },
    { id: 'tryKpis', title: 'page_title_goals', path: '/try-kpis' },
    { id: 'trySalesOrders', title: 'page_title_salesorders', path: '/try-sales-orders' },
    { id: 'tryProducts', title: 'page_title_products', path: '/try-products' },
    { id: 'tryBillboard', title: 'page_title_news', path: '/try-newsmanager' },
    { id: 'tryCampaigns', title: 'page_title_campaigns', path: '/try-salescampaigns' },
    { id: 'settings', title: 'title_myprofile_and_config', path: '/settings/*' },
    { id: 'customPage', title: 'title_custom_page', path: '/custom-page' },
    { id: 'dashboard', title: 'title_dashboard', path: '/dashboard' },
];

export const isNoSessionRoute = (hash = window.location.hash) =>
    EXTERNAL_ROUTE_METADATA.some(
        ({ noRedirectLogin, path }) => noRedirectLogin && hash.includes(path),
    );
